export default __webpack_public_path__ + "static/warehouse-presentation_by-4ff35936c375eba7560e6650afc0d5ec.webp";